import React from 'react';
import {LoadingWrapper} from "../Components/LoadingWrapper";
import EditableReactTableV2 from "../Components/ReactTable/EditableReactTableV2";
import Page from "../Components/Page";
import {Breadcrumbs} from "../Components/Breadcrumbs";
import {useServiceBase} from "../Components/ReactTable/useServiceBase";
import {
    EditFormBooleanDropdownInputField,
    EditFormMultiDropdownInputField,
    EditFormNumberInputField
} from "../Components/ReactTable/EditRecordForm";
import {RETAILER_ID_FIELD, RETAILER_ID_NAME_COLUMN} from "../Components/ReactTable/common_custom_columns";
import {serviceRetailerDropdown} from "../../utils/retailerDisplayFormatter";
import {checkForDuplicateRetailersForm} from "./serviceUtils";


export const ITEM_FIELDS_OPTIONS = [
    {value:"itemDescription", label: "itemDescription"},
    {value:"itemSize", label:"itemSize"},
    {value:"unitOfMeasure", label: "unitOfMeasure"}
]

const RetailerProduceItemFileOverrides = () => {
    const endpointUrl = `${process.env.REACT_APP_EDP_API_BASE_URL}/retailerProduceItemFileOverrides`;
    const {loading, data, onRowEditConfirmed, onRowDeleteConfirmed} = useServiceBase({endpointUrl});

    async function getOnRowEditConfirmedWrapper(newOrUpdatedRow) {
        console.log('newOrUpdatedRow Enter', newOrUpdatedRow);
        delete newOrUpdatedRow.standardizeField;
        if (!isFinite(newOrUpdatedRow['retailerIdOverride'])) {
            delete newOrUpdatedRow['retailerIdOverride'];
        }
        console.log('newOrUpdatedRow Exit', newOrUpdatedRow);
        await onRowEditConfirmed(newOrUpdatedRow);
    }
    function validatePreSave({rows, form}) {
        const retailerIdValue = form.getValues('retailerId');
        const indexValue = form.getValues('index');
        const hasDuplicate =  checkForDuplicateRetailersForm(retailerIdValue, indexValue, rows)

        if (hasDuplicate) {
            form.setError('retailerId', {
                type: 'custom',
                message: [`Retailer Id ${retailerIdValue} already exists in this config`]
            });
        }
        return !hasDuplicate;
    }

    return (
        <Page breadCrumbs={<Breadcrumbs items={[{label: "Services"}, {label: "Produce"}, {label: "Retailer Produce Item File Override"}]}/>} name={"Retail Produce Item File Overrides"}>
            <LoadingWrapper loading={loading}>
                <EditableReactTableV2
                    filterable
                    data={data.data}
                    columns={[
                        RETAILER_ID_NAME_COLUMN,
                        {header: "Item Fields", id: "itemFields", accessorKey: "itemFields"},
                        {header: "Retailer Override", id: "retailerIdOverride", accessorKey: "retailerIdOverride"},
                        {header: "No UOM in Items File", id: "noUnitOfMeasureItems", accessorKey: "noUnitOfMeasureItems"}]
                    }
                    editTable={[
                        RETAILER_ID_FIELD(serviceRetailerDropdown().data),
                        {id: 'itemFields', Component: args => <EditFormMultiDropdownInputField {...args} options={ITEM_FIELDS_OPTIONS} isRequired={true}/>},
                        {id: 'retailerIdOverride', Component: args => <EditFormNumberInputField {...args}/>},
                        {id: 'noUnitOfMeasureItems', Component: args => <EditFormBooleanDropdownInputField {...args}/>}
                    ]}
                    validatePreSave={validatePreSave}
                    initialState={{pagination: {pageSize: 25}}}
                    onRowEditConfirmed={getOnRowEditConfirmedWrapper}
                    onRowDeleteConfirmed={onRowDeleteConfirmed}
                />
            </LoadingWrapper>
        </Page>
    );
};

export default RetailerProduceItemFileOverrides;
